export default __webpack_public_path__ + "static/media/checkmark-thick.f30c42d8.svg";